<template>
  <!-- 绑卡引导弹窗：用户已配置完成 campaign，等待支付发布。仅允许通过下方操作按钮跳转关闭，不可通过遮罩 / 关闭按钮 / Esc 关闭 -->
  <a-modal v-if="visible" v-model="visible" title="" :centered="true" :footer="null" :closable="false"
    :maskClosable="false" :keyboard="false" :width="720" dialogClass="global-bind-card-modal-class">
    <div class="bind-modal-con">
      <h1 class="bind-title">
        <span class="title-emoji">&#128640;</span>
        <span>
          {{ $t("bindModalTitlePrefix") }}
          <strong>{{ $t("bindModalTitleMatch") }} {{ matchedNoun }}</strong>
          {{ $t("bindModalTitleSuffix") }}
        </span>
      </h1>

      <p class="bind-sales-version">
        <span class="swap-icon">&#128260;</span>
        {{ $t("bindModalSalesVersionLabel") }}:
        <span class="inline-emoji">&#128640;</span>
        {{ $t("bindModalSalesVersionText") }}
      </p>

      <p class="bind-description">
        {{ $t("bindModalDesc") }} &mdash;
        <strong>{{ $t("bindModalDescBold") }}</strong>
      </p>

      <div class="bind-campaign-card">
        <div class="card-head">
          <span class="pending-badge">{{ $t("bindModalPendingBadge") }}</span>
          <span class="campaign-name">{{ campaignName }}</span>
        </div>
        <p class="card-stats">
          <strong>{{ matchCount }}</strong>
          {{ $t("bindModalStatsSuffix") }} &middot;
          {{ $t("bindModalStatsReplies") }} &middot;
          {{ $t("bindModalStatsCreated", { date: createdDate }) }}
        </p>
      </div>

      <div class="bind-trial-notice">
        <span class="trial-emoji">&#127873;</span>
        <p>
          {{ $t("bindModalNoticePrefix") }}
          <strong>{{ $t("bindModalNoticeBold") }}</strong>
          {{ $t("bindModalNoticeSuffix") }}
        </p>
      </div>

      <div class="bind-action-row">
        <a-button type="primary" class="btn-continue" @click="handleContinue">
          {{ $t("bindModalContinueBtn") }}
          <span class="arrow">&rarr;</span>
        </a-button>
        <a-button class="btn-edit" @click="handleEditCampaign">
          {{ $t("bindModalEditBtn") }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";
import { EventOnEventStart, EventEnd } from "@/layouts/dialog-config/index";

const $EventName = "global_active_bindCardModal_20260802";

export default {
  name: "BindCardModal",
  data() {
    return {
      visible: false,
      // 下列字段通常来自父组件透传或 campaign 数据预填；
      // 默认值保持为空，避免在未加载数据时展示硬编码英文。
      campaignName: "",
      matchCount: 0,
      createdDate: "",
      matchedNoun: "",
    };
  },
  i18n: require("./i18n"),
  computed: {
    ...mapState("setting", ["lang"]),
    isSalesRoute() {
      return this.$route && this.$route.path.indexOf("/sales/salesReps") > -1;
    },
  },
  watch: {
    visible(flag) {
      if (!flag) {
        EventEnd($EventName);
      }
    },
    isSalesRoute: {
      immediate: true,
      handler() {
        this.matchedNoun = this.isSalesRoute ? this.$t("bindModalMatchedCustomer") : this.$t("bindModalMatchedCandidate");
      },
    },
  },
  async created() {
    EventOnEventStart($EventName, this.eventStartModal);
    // 初始单词根据当前路由决定
    this.matchedNoun = this.isSalesRoute ? this.$t("bindModalMatchedCustomer") : this.$t("bindModalMatchedCandidate");
  },
  beforeDestroy() {
    EventEnd($EventName);
  },
  methods: {
    // 通过 dialog-config 触发
    eventStartModal(data) {
      if (data && data.name === $EventName) {
        this.visible = true;
      }
    },
    closeModal() {
      this.visible = false;
      EventEnd($EventName);
    },
    // 继续 → 进入绑卡页（pricing/plan）
    handleContinue() {
      this.closeModal();
      this.$router.push({ path: "/setting/pricing/plan" });
    },
    // 编辑 campaign → 进入 createCampaign 编辑页
    handleEditCampaign() {
      this.closeModal();
      const target = this.isSalesRoute
        ? "/sales/salesReps/createCampaign"
        : "/hr/recruiter/createCampaign";
      this.$router.push({
        path: target,
        query: { linkedin_id: "current" },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bind-modal-con {
  padding: 30px 32px 30px;
  color: #101817;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.bind-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 14px;
  font-size: 22px;
  line-height: 1.35;
  font-weight: 800;
  color: #1d2c29;

  .title-emoji {
    flex-shrink: 0;
    font-size: 22px;
    line-height: 1.35;
  }

  strong {
    color: #0c8a72;
    font-weight: 900;
  }
}

.bind-sales-version {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 18px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f4f7f6;
  color: #5d6b68;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 700;

  .swap-icon,
  .inline-emoji {
    font-size: 14px;
    line-height: 1;
  }

  strong {
    color: #0c8a72;
    font-weight: 800;
  }
}

.bind-description {
  margin: 0 0 18px;
  color: #4a5552;
  font-size: 14px;
  line-height: 1.55;

  strong {
    color: #15211f;
    font-weight: 800;
  }
}

.bind-campaign-card {
  margin: 0 0 14px;
  padding: 16px 18px;
  border: 1px solid #dfe7e3;
  border-radius: 12px;
  background: #fff;
}

.card-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.pending-badge {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 6px;
  background: #fff3df;
  color: #b06a1d;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.campaign-name {
  color: #15211f;
  font-size: 15px;
  font-weight: 800;
}

.card-stats {
  margin: 0;
  color: #5d6b68;
  font-size: 13px;
  line-height: 1.5;

  strong {
    color: #0c8a72;
    font-weight: 800;
  }
}

.bind-trial-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 24px;
  padding: 14px 18px;
  border-radius: 12px;
  background: #ecf6f3;
  color: #21564c;
  font-size: 13px;
  line-height: 1.5;

  .trial-emoji {
    flex-shrink: 0;
    font-size: 16px;
    line-height: 1.5;
  }

  p {
    margin: 0;
  }

  strong {
    color: #0c8a72;
    font-weight: 800;
  }
}

.bind-action-row {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.btn-continue {
  flex: 1.6;
  min-width: 260px;
  height: 56px;
  padding: 0 22px;
  border: 0;
  border-radius: 10px;
  background: #f26122;
  color: #fff !important;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 8px 20px rgba(242, 97, 34, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover,
  &:focus {
    background: #e05517;
    color: #fff !important;
    transform: translateY(-1px);
    box-shadow: 0 12px 26px rgba(242, 97, 34, 0.28);
  }

  &:active {
    transform: scale(0.99);
  }

  .arrow {
    display: inline-block;
    margin-left: 6px;
  }
}

.btn-edit {
  flex: 1;
  min-width: 160px;
  height: 56px;
  padding: 0 22px;
  border: 1px solid #dfe7e3;
  border-radius: 10px;
  background: #fff;
  color: #1d2c29 !important;
  font-size: 16px;
  font-weight: 800;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;

  &:hover,
  &:focus {
    border-color: #0c8a72;
    background: #f4f7f6;
    color: #0c8a72 !important;
  }
}

@media (max-width: 720px) {
  .bind-modal-con {
    padding: 22px 16px;
  }

  .bind-title {
    font-size: 18px;
  }

  .bind-action-row {
    flex-direction: column;
  }

  .btn-continue,
  .btn-edit {
    width: 100%;
    min-width: 0;
  }
}
</style>
<style lang="less">
.global-bind-card-modal-class {
  width: 720px !important;
  max-width: calc(100vw - 32px);

  .ant-modal-body {
    padding: 0;
  }

  // 强制隐藏 antd 自带的右上角关闭按钮，确保不可关闭
  .ant-modal-close {
    display: none !important;
  }
}
</style>
